// src/app/components/tooltip-icon.tsx
//
// -- Migrated onto the kit, Phase 6 ------------------------------------------
//
// Kit 03 item 59 (`Tooltip`) and Kit 01's `Icon`. `ui/tooltip` is gone.
//
// The `size` prop went with it, and that is the point of F10's rule: icon size
// is `k-i k-i--md`, a CLASS, never a number passed as a prop, "because a prop
// puts a bare number back into component source where the lint cannot see it".
// Every call site passed 20 or nothing, and 20 is one of the four legal sizes,
// so nothing moved.
import type { LucideIcon } from "lucide-react";
import { Icon, Tooltip } from "./kit";
import type { IconSize } from "./kit";

interface TooltipIconProps {
  Icon: LucideIcon;
  tooltip: string;
  size?: IconSize;
  className?: string;
}

export function TooltipIcon({
  Icon: Glyph,
  tooltip,
  size = "lg",
  className = "",
}: TooltipIconProps) {
  return (
    <Tooltip label={tooltip} className={className}>
      <Icon icon={Glyph} size={size} />
    </Tooltip>
  );
}
